import { money } from "@/lib/landingSim";

export const LedgerTable = ({ lg, onDelete }) => (
  <div data-testid="ledger">
    <div className="grid grid-cols-3 gap-2 mb-3 text-sm">
      {[["Total charged", lg.total_charged, "text-slate-900"], ["Total paid", lg.total_paid, "text-green-700"], [lg.balance >= 0 ? "Balance owed" : "Credit", Math.abs(lg.balance), "text-blue-700"]].map(([l, v, c]) => (
        <div key={l} className="bg-slate-50 border border-slate-200 rounded-lg p-3"><p className="text-[10px] uppercase font-bold text-slate-400">{l}</p><p className={`text-lg font-black ${c}`} data-testid={`ledger-${l.toLowerCase().replace(/ /g, "-")}`}>{money(v)}</p></div>
      ))}
    </div>
    {lg.entries.length === 0 ? <p className="text-sm text-slate-400" data-testid="ledger-empty">No charges or payments yet.</p> : (
      <div className="overflow-x-auto max-h-[420px] overflow-y-auto"><table className="w-full text-sm">
        <thead className="text-[10px] uppercase text-slate-400 sticky top-0 bg-white"><tr><th className="text-left py-2">Date</th><th className="text-left">Description</th><th className="text-right">Charge</th><th className="text-right">Payment</th><th className="text-right">Balance</th>{onDelete && <th />}</tr></thead>
        <tbody>{lg.entries.map(e => (
          <tr key={e.id} className="border-b border-slate-100" data-testid={`ledger-row-${e.id}`}>
            <td className="py-2 pr-2 whitespace-nowrap text-xs text-slate-500">{e.created_at.slice(0, 10)}</td>
            <td className="pr-2">{e.description}</td>
            <td className="text-right whitespace-nowrap">{e.type === "charge" ? money(e.amount) : ""}</td>
            <td className="text-right whitespace-nowrap text-green-700">{e.type === "payment" ? money(e.amount) : ""}</td>
            <td className="text-right whitespace-nowrap font-semibold">{money(e.running_balance)}</td>
            {onDelete && <td className="text-right pl-2">{!e.session_id && <button onClick={() => onDelete(e)} className="text-xs text-slate-500 hover:text-red-600 underline" data-testid={`ledger-delete-${e.id}`}>Remove</button>}</td>}
          </tr>
        ))}</tbody>
      </table></div>
    )}
  </div>
);

export const StatementView = ({ st }) => (
  <div className="space-y-3" data-testid="statement-view">
    <div className="flex flex-wrap justify-between gap-2 text-sm">
      <p className="text-slate-500">Statement <b className="text-slate-900" data-testid="statement-number">{st.statement_number}</b> · {st.period_label}</p>
      <p className="text-slate-500">Due {st.due_date}</p>
    </div>
    <table className="w-full text-sm"><tbody>
      {st.current_charges.length === 0 && <tr><td className="py-2 text-slate-400">No new charges this period</td></tr>}
      {st.current_charges.map(c => <tr key={c.id} className="border-b border-slate-100"><td className="py-2">{c.description}</td><td className="text-right whitespace-nowrap">{money(c.amount)}</td></tr>)}
      <tr className="text-slate-500"><td className="pt-2">Previous balance</td><td className="pt-2 text-right">{money(st.previous_balance)}</td></tr>
      {st.payments_total > 0 && <tr className="text-green-700"><td>Payments this period</td><td className="text-right">−{money(st.payments_total)}</td></tr>}
      <tr className="font-black text-blue-700 text-lg"><td className="pt-2">Amount due</td><td className="pt-2 text-right" data-testid="statement-amount-due">{money(st.amount_due)}</td></tr>
    </tbody></table>
  </div>
);
